<script>
import FeaturePlaceholder from './FeaturePlaceholder.vue';
export default {
  components: { FeaturePlaceholder },
  props: {
    message: {
      type: String,
      required: true,
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full px-6">
    <div class="flex flex-col items-center gap-4 px-8 py-10 rounded-2xl border border-n-weak dark:border-n-alpha-3 bg-white dark:bg-n-solid-2/60 shadow-md max-w-sm w-full">
      <div class="grid place-content-center size-16 rounded-2xl bg-n-alpha-2 border border-n-alpha-3">
        <img
          class="w-8 hidden dark:block"
          src="dashboard/assets/images/no-chat-dark.svg"
          alt="No Chat"
        />
        <img
          class="w-8 block dark:hidden"
          src="dashboard/assets/images/no-chat.svg"
          alt="No Chat"
        />
      </div>
      <div class="flex flex-col items-center gap-1.5 text-center">
        <span class="text-sm font-semibold text-n-slate-12">
          {{ message }}
        </span>
        <span class="text-xs text-n-slate-10">
          Select a conversation from the left panel to get started.
        </span>
      </div>
      <FeaturePlaceholder />
    </div>
  </div>
</template>
